import { IPropertyMultModel, IPropertyModel } from "../property/index";
import { IPropertyDescriptionModel } from "../property/property-description.model";
import { IPropertyConfigurations } from "../property/property-configurations.model";
import {
	PersonEditModel,
} from "../person";
import { IDemandModel } from "../demand";
import { ITaskModel } from "../task";
import {  IAppointmentModel } from '../agenda';
import { ICompanyEditModel } from "../person/company.model";

export interface IPropertyCacheData {
    PropertyConfiguration?: IPropertyConfigurations;
    Property?: IPropertyModel;
    OriginalProperty?: IPropertyModel;
    PropertySubcategory?: IPropertyMultModel;
    PropertyDescription?: IPropertyDescriptionModel;
    HadSelectedPortalBeforeTypeChange?: boolean;
}

export class PropertyCacheData implements IPropertyCacheData {
    PropertyConfiguration?: IPropertyConfigurations;
    Property?: IPropertyModel;
    OriginalProperty?: IPropertyModel;
    PropertySubcategory?: IPropertyMultModel;
    PropertyDescription?: IPropertyDescriptionModel;
    HadSelectedPortalBeforeTypeChange?: boolean;

    constructor(props?: IPropertyCacheData) {
        this.PropertyConfiguration = props.PropertyConfiguration || null;
        this.Property = props.Property || null;
        this.OriginalProperty = props.OriginalProperty || null;
        this.PropertySubcategory = props.PropertySubcategory || null;
        this.PropertyDescription = props.PropertyDescription || null;
        this.HadSelectedPortalBeforeTypeChange = props.HadSelectedPortalBeforeTypeChange || false;
    }
}

export interface IPersonCacheData {
    Person?: PersonEditModel;
    OriginalPerson?: PersonEditModel;
    InitiatedDataTabs?: string[];
    AdditionalInfo?: object;
}
export class PersonCacheData {
    Person?: PersonEditModel;
    OriginalPerson?: PersonEditModel;
    InitiatedDataTabs?: string[];
    AdditionalInfo?: object;
    constructor(props?: IPersonCacheData) {
        this.Person = props.Person || null;
        this.OriginalPerson = props.OriginalPerson || null;
        this.InitiatedDataTabs = props.InitiatedDataTabs || [];
        this.AdditionalInfo = props.AdditionalInfo || {};
    }

}

export interface IAppointmentCacheData {
    Appointment?: IAppointmentModel;
    OriginalAppointment?: IAppointmentModel;
}
export class AppointmentCacheDataModel {
    Appointment?: IAppointmentModel;
    OriginalAppointment?: IAppointmentModel;
    constructor(props?: IAppointmentCacheData) {
       this.Appointment = props.Appointment || null;
       this.OriginalAppointment = props.OriginalAppointment || null;
    }

}

export interface IDemandCacheData {
    Demand?: IDemandModel;
    OriginalDemand?: IDemandModel;
}
export class DemandCacheData implements IDemandCacheData{
    Demand?: IDemandModel;
    OriginalDemand?: IDemandModel;
    constructor(props?: IDemandCacheData) {
        this.Demand = props.Demand || null;
        this.OriginalDemand = props.OriginalDemand || null;
    }

}

export interface ITaskCacheData {
    Task?: ITaskModel;
    OriginalTask?: ITaskModel;
}
export class TaskCacheData implements ITaskCacheData {
    Task?: ITaskModel;
    OriginalTask?: ITaskModel;
    constructor(props?: ITaskCacheData) {
        this.Task = props.Task || null;
        this.OriginalTask = props.OriginalTask || null;
    }

}

export interface ICompanyCacheData {
	Company?: ICompanyEditModel;
	OriginalCompany?: ICompanyEditModel;
}
export class CompanyCacheData implements ICompanyCacheData {
	Company?: ICompanyEditModel;
	OriginalCompany?: ICompanyEditModel;
	constructor(props?: ICompanyCacheData) {
		if (props) {
			Object.assign(this, props);
		}
	}
}

export interface IAutoTranslation {
    systemConfig : any
}
export class AutoTranslation implements IAutoTranslation {
    systemConfig : any

    constructor(props ?:IAutoTranslation) {
        if (props) {
            Object.assign(this, props);
        }
    }

}

export  enum  STATUS_ACTIVE  {
    ACTIVE= 1,
    NOT_ACTIVE= 0
}
export interface IMissedCallCachedData {
    phone : string,
    name ?: string,
    time :string,
    is_active:STATUS_ACTIVE,
    personId ?: number,
    companyId ?: number,
    reference ?: string,
    firstName ?: string,
    lastName ?: string,
    companyName ?: string
}
// export class MissedCallCachedData implements IMissedCallCachedData {
//     constructor(props:IMissedCallCachedData) {
//         Object.assign(this, this.props)
//     }
// }

export interface ICachedData<TData> {
    Id?: number;
    Action?: string;
    ModuleName?: string;
    Data?: TData;
}

export class CachedDataModel<TData> implements ICachedData<TData> {
    Id?: number;
    Action?: string;
    ModuleName?: string;
    Data?: TData;

    constructor(props?: ICachedData<TData>) {
        this.Id = props.Id || null;
        this.Action = props.Action || null;
        this.ModuleName = props.ModuleName || null;
        this.Data = props.Data || null;
    }

    storeData(payload: TData) {
        this.Data = payload;
    }
}